var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-screen',{attrs:{"title":_vm.$t('grace-period-expired.title'),"message":_vm.$t('grace-period-expired.message'),"show-exit-button":false,"image":'dizzy-robot.svg'}})}
var staticRenderFns = []

export { render, staticRenderFns }